/**
 * Mette insieme quello che i servizi tengono separato.
 *
 * L'elenco degli utenti dice chi sono; jurisdiction dove stanno nella rete;
 * credit quanto hanno. Ognuno risponde di quello che possiede, e chi disegna
 * una tabella ha bisogno di tutte e tre le cose insieme.
 *
 * Le chiamate sono due, non una per riga: un master con cinquanta agenzie
 * aprirebbe altrimenti cinquanta connessioni per una schermata sola.
 */

function intestazioni() {
  const env = (typeof window !== 'undefined' && window.env) || {};
  const token = typeof window !== 'undefined'
    ? window.localStorage.getItem('access_token') : null;

  return {
    Authorization: token ? `Bearer ${token}` : '',
    'Content-Type': 'application/json',
    'X-Client-Surface': 'FRONTEND',
    TENANT_ID: env.REACT_APP_API_TENANT || 1,
  };
}

function base() {
  const env = (typeof window !== 'undefined' && window.env) || {};
  return env.REACT_APP_API_URL || '';
}

/** Chi sta sotto chi: lo sa jurisdiction-service e nessun altro. */
export async function conGerarchia(list) {
  try {
    const res = await fetch(`${base()}/private/jurisdiction/all`, {
      headers: intestazioni(),
    });
    if (!res.ok) return list;

    const nodi = await res.json();
    const perId = {};
    for (const n of nodi) perId[n.userId] = n;

    return list.map((u) => {
      const n = perId[u.userId];
      return n ? { ...u, parentUserId: n.parentId, type: n.type || u.type } : u;
    });
  } catch (e) {
    console.warn('Gerarchia non disponibile:', e.message);
    return list;
  }
}

/** Le cinque cifre del conto, per tutti in una volta. */
export async function conCifre(list) {
  if (!list.length) return list;

  try {
    const res = await fetch(`${base()}/private/credit/figures`, {
      method: 'POST',
      headers: intestazioni(),
      body: JSON.stringify(list.map((u) => u.userId)),
    });
    if (!res.ok) return list;

    const cifre = await res.json();
    const perId = {};
    for (const f of cifre) perId[f.userId] = f;

    // Il servizio parla inglese, le schermate italiano: la traduzione sta qui,
    // in un punto solo.
    return list.map((u) => {
      const f = perId[u.userId];
      if (!f) return u;
      return {
        ...u,
        fidoRete: f.networkCredit,
        disponibilita: f.available,
        saldoUtente: f.userBalance,
        saldoTotRete: f.networkBalance,
        fidoDisp: f.creditAvailable,
        currency: f.currency || u.currency,
      };
    });
  } catch (e) {
    console.warn('Cifre non disponibili:', e.message);
    return list;
  }
}

/** Entrambe, nell'ordine giusto. */
export async function completa(list) {
  return conCifre(await conGerarchia(list));
}
